import BaseCarousel from '../abstracts/BaseCarousel';

export default class SectionsCarouselComponent extends BaseCarousel {
  constructor(element) {
    super(element);

    this.$el.addEventListener('glide.build.after', event => {
      const glide = event.detail.glide;
      glide.on('run.after', () => {
        this.updateCarouselPosition(glide);
      });
    });

    setTimeout(() => this.mount(this.$el, this.$options), 100);
  }

  updateCarouselPosition(glide) {
    let position = this.$el.querySelector('.sections-carousel-position');
    if (!position) {
      return;
    }
    position.textContent = position.textContent.replace(/\d+/, (glide.index + 1).toString().padStart(2, '0'));
  }
}
